module.exports = __webpack_public_path__ + "media/images/ra-review-color-4e22570c25225d6ec6ccf43562aac18b.svg";